import { getArea, getFid } from "./plot-utils";
import i18n from "../i18n";

const getLanduseAr = (typeOfUse?: string | number): string => {
  if (!typeOfUse) return "";
  return i18n.t(`type-of-use-tag.${String(typeOfUse).toLowerCase()}`, {
    lng: "ar",
    defaultValue: "",
  });
};

export function isInvestBtnDisabled(card: {
  typeOfUse?: string;
  status?: string;
}): boolean {
  return (
    card?.typeOfUse === "Governmental" ||
    card?.status === "Rented" ||
    card?.status === "Booked" ||
    card?.status === "Not Applicable"
  );
}

export function getFloorName(
  card: { floorEn?: string; floorAr?: string },
  language: string,
  fallback: string,
): string {
  if (language === "ar" && card.floorAr) {
    return card.floorAr;
  }
  if (language === "en" && card.floorEn) {
    return card.floorEn;
  }
  return fallback;
}

export const transformInvestmentOpportunities = (
  allFeatures: any[],
  dictionaries: any,
) => {
  return allFeatures.map((item) =>
    transformInvestmentOpportunity(item, dictionaries),
  );
};
export const transformInvestmentOpportunity = (
  item: any,
  dictionaries: any,
) => {
  const typeOfUse = dictionaries["Landuse"]?.[item.Landuse] || item.Landuse;
  return {
    number: item.PlotNum,
    area: Math.round(getArea(item)).toString(),
    city: dictionaries["estateEn"]?.[item.estateEn] || item.estateEn,
    cityId: item.estateID,
    landUseId: item.Landuse,
    typeOfUse,
    typeOfUseAr: getLanduseAr(typeOfUse),
    invOpNameAr: item.InOp_nam_a?.trim(),
    invOpNameEn: item.InOp_nam_e?.trim(),
    fid: getFid(item).toString(),
    status: item.status,
    geometry: item.geometry,
    layer: item.layer,
    objectId: item.objectId,
    estateAr: dictionaries["estateAr"]?.[item.estateAr] || item.estateAr,
    estateEn: item.estateEn,
    prodtype_e: item.prodtype_e,
    tenant_id: item.tenant_id,
    type: "InvestmentOpportunities",
    is_inv_op: item.is_inv_op,
    annualRate: item.Annual_Rent,
  };
};

export const transformPlots = (allFeatures: any[], dictionaries: any) => {
  return allFeatures.map((plot) => transformPlot(plot, dictionaries));
};

export const transformPlot = (plot: any, dictionaries: any) => {
  const fullLocationStatus =
    dictionaries["location_status_code"]?.[plot.location_status_code] ||
    plot.location_status_code;
  const parts = fullLocationStatus?.split("-") || [];
  const englishLocationStatus = parts[0]?.trim() || fullLocationStatus;
  const arabicLocationStatus = parts.slice(1).join("-").trim() || englishLocationStatus;
  const typeOfUse = dictionaries["Landuse"]?.[plot.Landuse] || plot.Landuse;
  return {
    number: plot.PlotNum,
    area: Math.round(getArea(plot)).toString(),
    locationStatusCode: englishLocationStatus,
    locationStatusCodeAr: arabicLocationStatus,
    locationStatusCodeId: plot.location_status_code,
    city: dictionaries["estateEn"]?.[plot.estateEn] || plot.estateEn,
    cityId: plot.estateID,
    fid: getFid(plot),
    status: plot.status,
    landUseId: plot.Landuse,
    typeOfUse,
    typeOfUseAr: getLanduseAr(typeOfUse),
    geometry: plot.geometry,
    layer: plot.layer,
    objectId: plot.objectId,
    estateAr: dictionaries["estateAr"]?.[plot.estateAr] || plot.estateAr,
    phase:
      dictionaries["parent_location_Serial"]?.[plot.parent_location_Serial] ||
      plot.parent_location_Serial,
    phaseId: plot.parent_location_Serial,
    estateEn: plot.estateEn,
    prodtype_e: plot.prodtype_e,
    tenant_id: plot.tenant_id,
    type: "Plots",
    is_inv_op: plot.is_inv_op,
    annualRate: plot.Annual_Rent,
  };
};

export const transformSpacesForRent = (
  allFeatures: any[],
  citiesMapEn: Map<number, string>,
  citiesMapAr: Map<number, string>,
) => {
  return allFeatures.map((space) => ({
    number: space["Office_Num"] ?? space["OfficeNum"],
    city: citiesMapEn.get(space.estateid),
    cityId: space.estateid,
    building: space.building_e,
    status: space.status,
    typeOfUse: space.landuse_e,
    typeOfUseAr: getLanduseAr(space.landuse_e),
    fid: (
      space["KOM_DBO_Spaces_fid"] ??
      space["DBO.KOM_Office_Spaces_40.fid"] ??
      ""
    ).toString(),
    layer: space.layer,
    floorEn: space.floor_e,
    floorAr: space.floor_a,
    area: Math.round(space.Shape__Area).toString(),
    estateId: space.estateid,
    objectId: space.objectId,
    estateAr: citiesMapAr.get(space.estateid),
    geometry: space.geometry,
    is_inv_lan: space["is_inv_lan"] ?? space["Invest"],
    estateEn: space.estateid,
    prodtype_e: space.prodtype_e,
    tenant_id: space.tenant_id,
    type: "SpacesForRent",
    annualRateMax: space.Annual_Rent_Max,
    annualRateMin: space.Annual_Rent_Min,
  }));
};
